import reminderMessageController from '~/config/server/reminder-service/reminder-message.controller';
import appMsgController from '~/config/server/reminder-service/app-msg.controller';
import mobilePositionController from '~/config/server/reminder-service/mobile-position.controller';
export var reminderService = {
    mobilePositionController: mobilePositionController,
    reminderMessageController: reminderMessageController,
    appMsgController: appMsgController
};
